import { lazy } from 'react'

const UserRoutes = [
    {
        path: '/user/settings',
        component: lazy(() => import('../../views/account-settings')),
        exact: true
    },
    {
        path: '/user/tipster-settings',
        component: lazy(() => import('../../views/account-settings/tipster-settings')),
        exact: true
    },
    {
        path: '/user/checkout',
        component: lazy(() => import('../../views/checkout')),
        exact: true
    },
    {
        path: '/checkout/:id',
        component: lazy(() => import('../../views/checkout/checkoutPayment')),
        exact: true
    },
    {
        path: '/user/:id',
        component: lazy(() => import('../../views/userProfile')),
        exact: true,
        meta: {
            publicRoute: true,
            menuCollapsed: true
        }
    },
    {
        path: '/payment/success',
        component: lazy(() => import('../../views/payments/success')),
        exact: true,
        meta: {
            publicRoute: true,
            menuCollapsed: true
        }
    },
    {
        path: '/payment/fail',
        component: lazy(() => import('../../views/payments/fail')),
        exact: true,
        meta: {
            publicRoute: true,
            menuCollapsed: true
        }
    },
    {
        path: '/profiles',
        component: lazy(() => import('../../views/profiles')),
        exact: true
    },
    {
        path: '/profiles/add',
        component: lazy(() => import('../../views/profiles/add')),
        exact: true
    },
    {
        path: '/profiles/update/:id',
        component: lazy(() => import('../../views/profiles/update')),
        exact: true
    }
]

export default UserRoutes
